{
  "version": 1,
  "asset_id": "9155164d-d8f0-400f-a402-56265ff7da24",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/9155164d-d8f0-400f-a402-56265ff7da24/destination-roofing-galvalume-metal-roof-inverness-fl-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/9155164d-d8f0-400f-a402-56265ff7da24/destination-roofing-galvalume-metal-roof-inverness-fl-1200w.webp",
  "original_filename": "destination-roofing-galvalume-metal-roof-inverness-fl-1200w.webp",
  "size": 237370,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:21Z"
}
